export default __webpack_public_path__ + "static/media/accountingAutomation-blue.880d2d26.svg";